module.exports = __webpack_public_path__ + "media/components/user_profile/icons/pencil-43ff5d04f73860041eeb64c81c33b3d9.svg";